import React, { useContext, useState } from "react";
import { CTAButtons } from "../components/ctaButtons";
import { ProductItem } from "../components/ProductItem";
import { ProductsList, Translations } from "../models/API";
import { CompareProductProps } from "../models/comapreResults";
import { StaticSettingsAppContext } from "./App/App";

interface ProductResultsProps extends CompareProductProps {
  productResults: ProductsList[];
  dictionaryElements: Translations;
  compareUrl: string;
  inquiryUrl: string;
  toggleMobileFilters: (ev: React.PointerEvent<HTMLButtonElement>) => void;
}

export const ResultProducts = (props: ProductResultsProps) => {
  const resultsLength = props.productResults.length;
  const STATIC_SETTINGS_APP = useContext(StaticSettingsAppContext);
  const [compareProductsSelected, setCompareProductsSelected] = useState([]);
  const [dataForInquiry, setDataForInquiry] = useState([]);

  const ProductItems = props.productResults.map((singleProduct) => (
    <ProductItem
      dictionary={{
        CompareText: props.dictionaryElements.CompareText,
        InquiryText: props.dictionaryElements.InquiryText,
        GradeColumnText: props.dictionaryElements.GradeColumnText,
        ContactUsText: props.dictionaryElements.ContactUsText,
        FirstColumnText: props.dictionaryElements.FirstColumnText,
        ContactUsUrl: props.dictionaryElements.ContactUsUrl,
      }}
      productData={singleProduct}
      dataForInquiry={dataForInquiry}
      setDataForInquiry={setDataForInquiry}
      compareProductsSelected={compareProductsSelected}
      setCompareProductsSelected={setCompareProductsSelected}
      key={singleProduct.Id}
    />
  ));
  return (
    <div className="results-holder">
      <div className="mobile-filter-button">
        <button
          id={"show-filters-" + STATIC_SETTINGS_APP.APP_VARIANT}
          className="button"
          onClick={props.toggleMobileFilters}
        >
          {props.dictionaryElements.ShowFiltersText}
        </button>
      </div>
      <div className="header-row">
        <div className="header">{props.dictionaryElements.ResultsText}</div>
        <div className="numbers">
          {`${resultsLength} ${props.dictionaryElements.ResultsQuantityText}`}
        </div>
      </div>
      <div className="items">{ProductItems}</div>
      {resultsLength > 0 && (
        <CTAButtons
          api={{ inquiryUrl: props.inquiryUrl, compareUrl: props.compareUrl }}
          dictionary={{
            makeInquiryText: props.dictionaryElements.MakeInquiryText,
            compareText: props.dictionaryElements.CompareProductsText,
          }}
          data={{
            dataForInquiry: dataForInquiry,
            dataForCompare: compareProductsSelected,
            compareProductsLength: compareProductsSelected.length,
          }}
          setCompareResults={props.setCompareResults}
        />
      )}
    </div>
  );
};
